const mdMediaQuery = window.matchMedia('(max-width: 992px)');
const tp_url = 'https://api.trustpilot.com/v1/business-units/5bae2f308d99e600014b32ac';
const apikey = '8XnfBBjyvj01VkZP3xMGtX3W0QAvU39G';

document.querySelectorAll('.trust-block-v2').forEach(block => {
  const scrollContainer = block.querySelector<HTMLElement>('.scroll-nav-container');
  const scrollNav = block.querySelector<HTMLElement>('.scroll-nav');
  const navButtons = scrollNav?.querySelectorAll<HTMLElement>('button');

  const setScrollOpacity = (scrollLeft: number, scrollOffset: number) => {
    scrollContainer?.style.setProperty('--left-opacity', scrollLeft !== 0 ? '1' : '0');
    scrollContainer?.style.setProperty('--right-opacity', scrollLeft <= scrollOffset ? '1' : '0');
  };

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class' && mutation.target instanceof HTMLElement && mutation.target.classList.contains('active')) {
        const element = mutation.target;
        const index = Array.from(navButtons || []).indexOf(element as HTMLElement);

        const scrollOffset = 50;

        if (index === 0) {
          scrollNav!.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (index === navButtons!.length - 1) {
          scrollNav!.scrollTo({ left: scrollNav!.scrollWidth - scrollNav!.clientWidth, behavior: 'smooth' });
        } else {
          const elementLeft = element.offsetLeft;
          const elementRight = elementLeft + element.offsetWidth;
          const scrollLeft = scrollNav!.scrollLeft;
          const scrollRight = scrollLeft + scrollNav!.clientWidth;

          if (elementLeft < scrollLeft) {
            scrollNav!.scrollTo({ left: elementLeft - scrollOffset, behavior: 'smooth' });
          } else if (elementRight > scrollRight) {
            scrollNav!.scrollTo({ left: elementRight - scrollNav!.clientWidth + scrollOffset, behavior: 'smooth' });
          }
        }
      }
    });
  });

  if (scrollNav) {
    observer.observe(scrollNav, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  handleSettingScrollOpacity();

  function handleSettingScrollOpacity(): void {
    const scrollOffset = (scrollNav?.scrollWidth || 0) - (scrollContainer?.scrollWidth || 0);
    if (scrollOffset > 0) {
      scrollNav?.addEventListener('scroll', e => setScrollOpacity((e.target as HTMLElement).scrollLeft, scrollOffset));
      if (scrollNav) {
        setScrollOpacity(scrollNav.scrollLeft, scrollOffset);
      }
    } else {
      scrollNav?.removeEventListener('scroll', e => setScrollOpacity((e.target as HTMLElement).scrollLeft, scrollOffset));
      scrollContainer?.style.setProperty('--left-opacity', '0');
      scrollContainer?.style.setProperty('--right-opacity', '0');
    }
  }

  // Listen for media query changes
  mdMediaQuery.addEventListener('change', () => handleSettingScrollOpacity());

  block.querySelectorAll<HTMLElement>('.trust-box .quote').forEach(async quote => {
    if (quote.dataset.latestRating !== undefined) {
      try {
        const data = await fetch(
          tp_url +
            '/reviews?' +
            new URLSearchParams({
              apikey,
              tagValue: quote.dataset.tag || '',
              language: en ? 'en' : 'de',
              stars: '5',
              perPage: '1'
            })
        ).then(response => response.json());
        const review = data.reviews[0];
        quote.querySelector<HTMLElement>('.author strong')!.textContent = review.consumer.displayName;
        quote.querySelector<HTMLElement>('.text-quote')!.textContent = '„' + review.text + '”';
        block.querySelector<HTMLElement>('.trust-slider')?.slider?.updateContainerHeight();
      } catch {
        return;
      }
    }
  });
});
